import { Component, OnInit } from '@angular/core';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FieldTypeEnum } from '../../../../../../models/enums/field-type.enum';

@Component({
  selector: 'jhi-bary-modal-edit-with-confirm',
  templateUrl: './bary-modal-edit-with-confirm.component.html',
  styleUrls: ['./bary-modal-edit-with-confirm.component.scss'],
})
export class BaryModalEditWithConfirmComponent implements OnInit {
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  messageFn!: (...args: any[]) => any;
  icon: string | undefined;
  staticMessage: string | undefined;
  fieldType?: FieldTypeEnum;
  fieldOptions?: any;
  label!: string;
  value?: string;
  public enableSubmitBtn: boolean = false;
  control?: FormControl;
  isModification = true;
  buttons!: { submit: any; cancel: any };

  _control = new FormControl();
  INPUT_MULTI_SELECT = FieldTypeEnum.INPUT_MULTI_SELECT;
  INPUT_SELECT = FieldTypeEnum.INPUT_SELECT;
  INPUT_TEXT = FieldTypeEnum.INPUT_TEXT;

  constructor(public modalRef: MDBModalRef, private translateService: TranslateService) {
    this.buttons = {
      submit: this.translateService.instant('modals.editWithConfirm.submit'),
      cancel: this.translateService.instant('modals.editWithConfirm.cancel'),
    };
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  ngOnInit(): void {
    if (this.control) {
      this._control = new FormControl(this.control.value, this.control.validator);
    } else {
      this._control = new FormControl(this.value, [Validators.max(250)]);
    }
  }

  hasValueDiff(): boolean {
    return this.control ? this.control.value !== this._control.value : this.value !== this._control.value;
  }
}
